module.exports = __webpack_public_path__ + "static/media/discount.cec72d6c.svg";